import { render, staticRenderFns } from "./settingGrid.vue?vue&type=template&id=30688a00&scoped=true&"
import script from "./settingGrid.vue?vue&type=script&lang=js&"
export * from "./settingGrid.vue?vue&type=script&lang=js&"
import style0 from "./settingGrid.vue?vue&type=style&index=0&id=30688a00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30688a00",
  null
  
)

export default component.exports